import React from "react";
import {
  DropdownAndMiniLogoWrapper,
  DropdownIcon,
  DropdownSiteDiv,
  DropdownSiteLi,
  DropdownSitesWrapper,
  HeaderTab,
  HeaderTabCompanies as HeaderTabCompanies,
  HeaderTabLink,
  HeaderTabPrivates,
  menuTheme,
  SiteSelection,
  ContainerDiv,
} from "./UpperHeader.style";
import { Menu } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { CommonMFE, Helpers } from "@tpd-web-common-libs/nodejs-library";
import { ReactMFE } from "@tpd-web-common-libs/nodejs-library";

type TUpperHeaderProps = {
  id: string;
  __host__: any;
  corporateLinks: any;
  isEditMode: boolean;
};

const UpperHeader = (props: TUpperHeaderProps) => {
  const { __host__, corporateLinks, isEditMode } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isDropdownOpen = Boolean(anchorEl);
  const handleDropdownClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };
  const isAziendeSelected = Helpers.UrlHelper.isHostUrlSubPathOf(
    __host__.url,
    "aziende"
  );

  const isHCLPage = Helpers.PageHelper.isHCLAuthoringPage();

  return (
    <ContainerDiv>
      <HeaderTabPrivates>
        <HeaderTab className={!isAziendeSelected ? "header-tabs-active" : ""}>
          <HeaderTabLink
            __deps__={React}
            href={isHCLPage ? '/tpdweb/homepage' : '/homepage'}
            data-disabled={isEditMode}
          >
            Privati
          </HeaderTabLink>
        </HeaderTab>
      </HeaderTabPrivates>
      <HeaderTabCompanies>
        <HeaderTab className={isAziendeSelected ? "header-tabs-active" : ""}>
          <HeaderTabLink
            __deps__={React}
            href={isHCLPage ? '/tpdweb/aziende' : '/aziende'}
            data-disabled={isEditMode}
          >
            Aziende
          </HeaderTabLink>
        </HeaderTab>
      </HeaderTabCompanies>
      <SiteSelection>
        <DropdownAndMiniLogoWrapper>
          <DropdownSitesWrapper>
            <DropdownSiteDiv onClick={handleDropdownClick}>
              {corporateLinks.sitoCliente.name}
              {anchorEl ? (
                <DropdownIcon className="icon-Freccia-up" />
              ) : (
                <DropdownIcon className="icon-Freccia-down" />
              )}
            </DropdownSiteDiv>
            <ThemeProvider theme={menuTheme}>
              <Menu
                open={isDropdownOpen}
                anchorEl={anchorEl}
                onClose={handleCloseDropdown}
                transitionDuration={0}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <DropdownSiteLi onClick={handleCloseDropdown}>
                  <a>{corporateLinks.sitoCliente.name}</a>
                </DropdownSiteLi>
                {corporateLinks.sitoCliente.subMenu.map((corporateLink) => (
                  <DropdownSiteLi
                    onClick={handleCloseDropdown}
                    key={corporateLink.id}
                  >
                    <ReactMFE.Link
                      __deps__={React}
                      href={corporateLink.url}
                      target="_blank"
                      rel="noreferer, ,noopener"
                      data-disabled={isEditMode}
                    >
                      {corporateLink.name}
                    </ReactMFE.Link>
                  </DropdownSiteLi>
                ))}
              </Menu>
            </ThemeProvider>
          </DropdownSitesWrapper>
        </DropdownAndMiniLogoWrapper>
      </SiteSelection>
    </ContainerDiv>
  );
};

export default UpperHeader;
